var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWorking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ap2l1mbysa",
    d: "M0 0.696L57.713 0.696 57.713 73.282 0 73.282z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-593 -415) translate(593.5 415) translate(0 .022)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sewpw8hfbb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ap2l1mbysa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    d: "M47.114 49.267C34.783 68.122 16.596 77.912 6.516 71.131c-10.086-6.771-8.264-27.56 4.083-46.42C22.94 5.864 41.12-3.935 51.194 2.846c10.089 6.774 8.268 27.559-4.08 46.422",
    mask: "url(#sewpw8hfbb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M45.715 20.944c.134 1.87-1.272 3.493-3.14 3.628-1.861.131-3.488-1.276-3.623-3.146-.134-1.869 1.275-3.488 3.141-3.62 1.868-.134 3.487 1.27 3.622 3.138",
    transform: "translate(-593 -415) translate(593.5 415)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M21.572 33.912c.064.894.244 1.756.524 2.566L8.788 51.828c-.893 1.03-1.332 2.348-1.236 3.708.096 1.364.718 2.605 1.754 3.5 1.028.892 2.345 1.331 3.708 1.234 1.36-.096 2.604-.718 3.497-1.748l13.305-15.349c.843.158 1.721.216 2.614.152 5.59-.398 9.816-5.27 9.418-10.862-.083-1.154-.359-2.277-.822-3.335-.172-.402-.543-.685-.978-.753-.433-.066-.87.097-1.158.426l-2.932 3.383c-.444.516-1.066.824-1.748.874-.68.05-1.339-.17-1.853-.617-1.068-.923-1.182-2.538-.257-3.605l2.93-3.38c.286-.33.386-.787.257-1.206-.13-.42-.464-.744-.885-.863-1.113-.303-2.26-.42-3.417-.335-5.588.398-9.813 5.268-9.413 10.86zm2.547-.183c-.296-4.185 2.867-7.831 7.048-8.13.125-.011.247-.017.373-.02l-1.372 1.583c-1.845 2.13-1.615 5.365.514 7.21 1.031.893 2.35 1.328 3.708 1.232 1.363-.095 2.607-.716 3.5-1.745l1.368-1.587c.02.125.031.248.042.373.295 4.185-2.866 7.834-7.052 8.135-4.18.298-7.83-2.869-8.129-7.051zm-3.04 7.822l2.259-2.606c.982 1.42 2.313 2.575 3.861 3.343l-2.26 2.609-3.86-3.346zm-10.103 15.55c-.514-.444-.825-1.065-.873-1.747-.05-.679.169-1.339.615-1.85l8.688-10.021 3.859 3.346-8.685 10.018c-.446.518-1.067.826-1.747.876-.682.047-1.34-.17-1.857-.621z",
    transform: "translate(-593 -415) translate(593.5 415)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorking);
export default __webpack_public_path__ + "static/media/icon_working.cd43b7c12be01d4edc8220d03cefeeea.svg";
export { ForwardRef as ReactComponent };